import React, { Component } from 'react';
import { Row, Col, Button, Input, Label, CustomInput, Form, UncontrolledTooltip } from 'reactstrap';
import { CommonHelper, MultiLangTextWithTitle, getCardAmountTagLanguages } from '../Base/Common/CommonUIComponents';
import { handleNotification } from '../Base/Common/Notification';
import { BlankCard } from '../Base/Common/CommonUIComponents';
import { FormattedMessage, injectIntl } from 'react-intl';
import Authorization from '../Base/Authorization';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import { getAPI } from '../Base/API';
import moment from "moment";
import CustomSelect from '../Base/Common/CustomSelect';
import { getMonetaryVoucherActions, getVoucherTagLabel, getVoucherValidUntilUnit } from '../Base/Common/ReferenceDataFunctions';

// Max length the backend accepts for a Hey!Card title (Request #21443).
const VOUCHER_TITLE_MAX_LENGTH = 50;

class VoucherConfigStep1 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            blblockTagsock: false,
            voucherTags:[]
        }
    }

    componentDidMount() {
        this.getVoucherTags();
    }

    getVoucherTags = () => {
        this.setState({ blockTags: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockTags: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }

                let tagOptions = [
                    { label: this.props.intl.formatMessage({ id: "generic.active" }), options: [] },
                    { label: this.props.intl.formatMessage({ id: "generic.inactive" }), options: [] }
                ];

                data.response && data.response.forEach((tag) => {
                    const obj = { label: getVoucherTagLabel(tag), value: tag.id };
                    
                    tagOptions[tag.active ? 0 : 1].options.push(obj);
                });

                this.setState({ voucherTags: tagOptions, blockTags: false });
            }
            else {
                this.setState({ blockTags: false });
            }
        }, `/api/Voucher/Voucher/v1/voucherTag`)
    }


    renderMonthElement = (action, { month, onYearSelect }) => {
        const selectedYear = month.year();
        const years = [
            { value: moment().year(), isDisabled: false },
            { value: moment().year() + 1, isDisabled: false },
            { value: moment().year() + 2, isDisabled: false }   
        ].filter(year => year.value !== selectedYear);

        if (!years.some(y => y === month.year())) {
            years.unshift({ value: month.year(), isDisabled: true })
        }

        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Row>
                    <Col className="pr-1">
                        {moment(month).locale(this.props.intl.locale).format('MMMM')}
                    </Col>
                    <Col className="pl-1">
                        <select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)} style={{ border: '1px solid #ced4da', borderRadius: '0.25rem' }}>
                            {years.map((year, key) =>
                                <option value={year.value} disabled={year.isDisabled} key={key}>
                                    {year.value}
                                </option>
                            )}
                        </select>
                    </Col>
                </Row>
            </div>
        );
    }
    
    render() {
        const { block, voucherConfig, taxCodes } = this.props;
        
        return (
            <BlankCard title='EditVoucher.VoucherConfig' block={block} >
                <Form onSubmit={this.props.saveVoucher}>
                    <Row className="align-items-center">
                        <Col>
                            <h5><FormattedMessage id="EditVoucher.VoucherConfig" /></h5>
                        </Col>
                        <Col className="text-right">
                            {this.props.canEditVoucher &&
                                <Authorization
                                    perform="cardConfigWizard:saveConfig"
                                    yes={() => (
                                        <Button className="btn-host btn-sm" type="submit">
                                            <i className="fa-solid fa-floppy-disk " />
                                        </Button>
                                    )}
                                    no={() => <div></div>}
                                />
                            }   
                        </Col>
                    </Row>
                    <hr className="my-1 border-host" />

                    <div style={{ zIndex: '99', position: 'relative' }}>
                        <Row className="mb-2 mt-3 align-items-center">
                            <Col className="col-2">
                                <Label>
                                    <b><FormattedMessage id="EditVoucher.Code" /></b>
                                </Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="EditVoucher.Code" >
                                    {
                                        placeholder => <Input type="text" placeholder={placeholder} required minLength="1" maxLength="50" value={voucherConfig.code ? voucherConfig.code : ''} name="code" onChange={this.props.updateForm.bind(this, 'voucherConfig')} />
                                    }
                                </FormattedMessage>
                            </Col>
                            <Col className="col-2">
                                <Label>
                                    <b><FormattedMessage id="EditVoucher.MaxQuantity" /></b>
                                </Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="EditVoucher.MaxQuantity" >
                                    {
                                        placeholder => <Input type="number" placeholder={placeholder} required min="1" max="1000000" value={voucherConfig.maxQuantity !== null ? voucherConfig.maxQuantity : ''} name="maxQuantity" onChange={this.props.updateForm.bind(this, 'voucherConfig')} />
                                    }
                                </FormattedMessage>
                            </Col>

                        </Row>

                        <Row className="mb-2 align-items-center">
                            <Col className="col-2">
                                <Label><b><FormattedMessage id="EditVoucher.PayedAmount" /></b></Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="EditVoucher.PayedAmount" >
                                    {
                                        placeholder => <Input type="number" placeholder={placeholder} required min="0" max="1000000000" step="0.01" value={voucherConfig.payedAmount !== null ? voucherConfig.payedAmount : ''} name="payedAmount" onChange={this.props.updateForm.bind(this, 'voucherConfig')} />
                                    }
                                </FormattedMessage>
                            </Col>
                            <Col className="col-2">
                                <Label><b><FormattedMessage id="EditVoucher.CardAmount" /></b></Label>
                            </Col>
                            <Col className="col-4">
                                <Input 
                                    required
                                    type="number"
                                    placeholder={this.props.intl.formatMessage({ id: "EditVoucher.CardAmount" })}
                                    min={voucherConfig.isPaymentMode ? "1" : "0"} 
                                    max="1000000000" step="0.01" 
                                    value={voucherConfig.cardAmount !== null ? voucherConfig.cardAmount : ''}
                                    name="cardAmount"
                                    onChange={this.props.updateForm.bind(this, 'voucherConfig')} 
                                />
                            </Col>
                        </Row>
                        <Row className="mb-2 align-items-center">
                            <Col className="col-2">
                                <Label><b><FormattedMessage id="EditVoucher.SalesPeriod" /></b></Label>
                            </Col>
                            <Col className="col-4">
                                <DateRangePicker
                                    key={this.state.focusedInput}
                                    startDate={voucherConfig.saleValidFrom ? moment(voucherConfig.saleValidFrom) : null}
                                    startDateId="saleValidFrom"
                                    isOutsideRange={day => day <= moment().subtract(6, 'month') || day > moment().add(24, 'month')}
                                    endDate={voucherConfig.saleValidTo ? moment(voucherConfig.saleValidTo) : null}
                                    endDateId="saleValidTo"
                                    onDatesChange={({ startDate, endDate }) => this.props.handleDatesChange('voucherConfig', startDate, endDate)}
                                    focusedInput={this.state.focusedInput}
                                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                                    small={true}
                                    required
                                    numberOfMonths={2}
                                    showDefaultInputIcon={true}
                                    initialVisibleMonth={() => {
                                        if (this.state.focusedInput === 'endDate' && voucherConfig.saleValidTo) {
                                            return moment(voucherConfig.saleValidTo);
                                        }
                                        if (voucherConfig.saleValidFrom) {
                                            return moment(voucherConfig.saleValidFrom);
                                        }
                                        return moment();
                                    }}
                                    renderMonthElement={props => this.renderMonthElement(this.props.action, props)}
                                />
                            </Col>
                            <Col className="col-2">
                                <Label><b><FormattedMessage id="EditVoucher.ValidUntil" /></b></Label>
                            </Col>
                            <Col className="col-4 d-flex align-items-center">
                                <div className='pr-2' style={{ width: '46%', zIndex: 950 }}>
                                    {voucherConfig.validUntilUnit === 'FixedDate' ?
                                        <SingleDatePicker
                                            date={voucherConfig.validUntilFixedDate ? moment(voucherConfig.validUntilFixedDate) : null}
                                            id="validUntilFixedDate"
                                            isOutsideRange={day => day < moment().subtract(1, 'day').startOf('day') || day > moment().add(24, 'month')}
                                            onDateChange={date => this.props.updateForm('voucherConfig', { target: { name: 'validUntilFixedDate', value: date } })} 
                                            focused={this.state.fixedDateFocusedInput === 'validUntilFixedDate'}
                                            onFocusChange={({ focused }) => this.setState({ fixedDateFocusedInput: focused ? 'validUntilFixedDate' : null })}
                                            small={true}
                                            showDefaultInputIcon={true}
                                            initialVisibleMonth={() => voucherConfig.validUntilFixedDate ? moment(voucherConfig.validUntilFixedDate) : moment()}
                                            renderMonthElement={props => this.renderMonthElement(this.props.action, props)}
                                        />
                                    :
                                        <Input 
                                            type="number" 
                                            min= {voucherConfig.validUntilUnit === 'Days' ? "0" : "1"}
                                            max="48" 
                                            required 
                                            value={voucherConfig.vouchersValidUntil !== null ? voucherConfig.vouchersValidUntil : ''} 
                                            name="vouchersValidUntil"
                                            onChange={this.props.updateForm.bind(this, 'voucherConfig')} 
                                            placeholder={voucherConfig.validUntilUnit === 'Days' ? this.props.intl.formatMessage({ id: "EditVoucher.NumDays" }) : this.props.intl.formatMessage({ id: "EditVoucher.NumMonth" })}
                                        />   
                                    }                          
                                </div>
                                <div className='pl-2' style={{ width: '46%', zIndex: 950 }}>
                                    <CustomSelect
                                        name='validUntilUnit'
                                        options={getVoucherValidUntilUnit(this.props.intl)}  
                                        value={voucherConfig.validUntilUnit ? getVoucherValidUntilUnit(this.props.intl).find(el => el.value === voucherConfig.validUntilUnit) : getVoucherValidUntilUnit(this.props.intl)[0]}
                                        onChange={this.props.updateVoucherValidUnit}
                                        placeholder={<FormattedMessage id="EditVoucher.ValidUntilUnit" />}
                                        required
                                    />
                                </div>
                                <div className='text-right mb-1' style={{ width: '8%' }}>
                                    <CommonHelper help={<FormattedMessage id="EditVoucher.ValidUntilHelper"/>} id="validUntilHelper"/>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mb-2 align-items-center">
                            <Col className="col-2">
                                <Label><b><FormattedMessage id="EditVoucher.TypePrefix" /></b></Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="EditVoucher.TypePrefix" >
                                    {
                                        placeholder => <Input type="text" placeholder={placeholder} minLength="1" maxLength="10" value={voucherConfig.defaultPrefix !== null ? voucherConfig.defaultPrefix : ''} name="defaultPrefix" onChange={this.props.updateForm.bind(this, 'voucherConfig')} />
                                    }
                                </FormattedMessage>
                            </Col>
                            <Col className="col-2">
                                <Label><b><FormattedMessage id="EditVoucher.DisplayOrder" /></b></Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="EditVoucher.DisplayOrder" >
                                    {
                                        placeholder => <Input type="number" min="1" max="1000" placeholder={placeholder} required minLength="1" maxLength="50" value={voucherConfig.order !== null ? voucherConfig.order : ''} name="order" onChange={this.props.updateForm.bind(this, 'voucherConfig')} />
                                    }
                                </FormattedMessage>
                            </Col>
                            {/*        <Col className="col-2">
                                    <Label><b><FormattedMessage id="EditVoucher.Active" /></b></Label>
                                </Col>
                                <Col className="col-4">
                                    
                                </Col>
                        */}
                        </Row>
                        <Row className="mb-2 align-items-center">
                            <Col className="col-2">
                                <Label><b><FormattedMessage id="EditVoucher.VouhcherTag" /></b></Label>
                            </Col>
                            <Col className="col-4" style={{ zIndex: 950 }}>
                                <CustomSelect
                                    name='voucherTagId'
                                    options={this.state.voucherTags}
                                    value={voucherConfig.voucherTagId ? this.state.voucherTags?.flatMap(el => el.options).find(el => el.value === voucherConfig.voucherTagId) : ''}
                                    onChange={this.props.updateComboForm}
                                    placeholder={<FormattedMessage id="EditVoucher.VouhcherTag" />}
                                    isLoading={this.state.blockTags}
                                    isClearable
                                />
                            </Col>

                            {voucherConfig.isPaymentMode === true ?
                                <>
                                    <Col className="col-2">
                                        <Label><b><FormattedMessage id="EditVoucher.DailyValueLimit" /></b></Label>
                                    </Col>
                                    <Col className="col-4">
                                        <Input 
                                            type="number"
                                            placeholder={this.props.intl.formatMessage({ id: "EditVoucher.DailyValueLimit" })}
                                            min="1" 
                                            max={voucherConfig.cardAmount ?? 9999} 
                                            step="0.01" 
                                            value={voucherConfig.dailyValueLimit ?? ''}
                                            name="dailyValueLimit"
                                            onChange={this.props.updateForm.bind(this, 'voucherConfig')} 
                                            disabled={voucherConfig.allowPartialRedeem === false}
                                        />
                                    </Col>
                                </>
                            : ''}
                        </Row>
                        {voucherConfig.isPaymentMode === true && global.modules?.some(m => m === 'InvoiceAction') ?
                            <Row className="mb-2 align-items-center">
                                <Col className="col-2">
                                    <Label><b><FormattedMessage id="EditVoucher.Action" /></b></Label>
                                </Col>
                                <Col className="col-4" style={{ zIndex: 99 }}>
                                    <CustomSelect
                                        name='action'
                                        options={getMonetaryVoucherActions(this.props.intl)}
                                        value={voucherConfig.action ? getMonetaryVoucherActions(this.props.intl).find(el => el.value === voucherConfig.action) : ''}
                                        onChange={this.props.updateComboForm}
                                        placeholder={<FormattedMessage id="EditVoucher.Action" />}
                                        isClearable
                                        required                                       
                                    />
                                </Col>
                            </Row>
                        : ''}

                        <Row className="mb-4 mt-4 align-items-center">
                            <Col className="col-2">
                                <Label><b><FormattedMessage id="EditVoucher.Options" /></b></Label>
                            </Col>
                            <Col className="d-flex align-items-center">
                                <CustomInput type="switch" label={<FormattedMessage id="EditVoucher.IsMoneyVoucher" />} checked={voucherConfig.isPaymentMode} name="isPaymentMode" id="isPaymentMode" onChange={(e) => this.props.handleVoucherType(e)} />
                                {!voucherConfig.isPaymentMode && (getCardAmountTagLanguages(voucherConfig.subjectTranslations).length > 0 || getCardAmountTagLanguages(voucherConfig.subjectGiftTranslations).length > 0) && (
                                    <>
                                        <span id="cardAmountNonMonetaryWarning" className="text-warning ml-2 pointer">
                                            <i className="fas fa-exclamation-triangle" />
                                        </span>
                                        <UncontrolledTooltip target="cardAmountNonMonetaryWarning" placement="right">
                                            {getCardAmountTagLanguages(voucherConfig.subjectTranslations).length > 0 &&
                                                <div>
                                                    <FormattedMessage
                                                        id="CardConfigWizard.SubjectAmountInNonMonetaryInline"
                                                        values={{ langs: getCardAmountTagLanguages(voucherConfig.subjectTranslations).join(', '), tag: '{{CardAmount}}' }}
                                                    />
                                                </div>
                                            }
                                            {getCardAmountTagLanguages(voucherConfig.subjectGiftTranslations).length > 0 &&
                                                <div>
                                                    <FormattedMessage
                                                        id="CardConfigWizard.SubjectGiftAmountInNonMonetaryInline"
                                                        values={{ langs: getCardAmountTagLanguages(voucherConfig.subjectGiftTranslations).join(', '), tag: '{{CardAmount}}' }}
                                                    />
                                                </div>
                                            }
                                        </UncontrolledTooltip>
                                    </>
                                )}
                            </Col>
                            <Col title={this.props.intl.formatMessage({ id: 'EditVoucher.IsRechargableTooltip' })}>
                                <CustomInput type="switch" label={<FormattedMessage id="EditVoucher.IsRechargable" />} checked={voucherConfig.isRechargable} name="isRechargable" id="isRechargable" onChange={this.props.handleSwitched.bind(this, 'voucherConfig')} disabled={!voucherConfig.isPaymentMode || !voucherConfig.allowPartialRedeem} />
                            </Col>
                            {voucherConfig.isPaymentMode ?
                                <Col>
                                    <CustomInput type="switch" label={<FormattedMessage id="EditVoucher.ParcialRedeem" />} checked={voucherConfig.allowPartialRedeem} name="allowPartialRedeem" id="allowPartialRedeem" onChange={this.props.handleSwitched.bind(this, 'voucherConfig')} />
                                </Col>
                            : ''}
                            {!voucherConfig.isPaymentMode ?
                                <Col title={this.props.intl.formatMessage({ id: 'EditVoucher.SingleDayRedeemTooltip' })}>
                                    <CustomInput type="switch" label={<FormattedMessage id="EditVoucher.SingleDayRedeem" />} checked={voucherConfig.singleDayRedeem === true} name="singleDayRedeem" id="singleDayRedeem" onChange={this.props.handleSwitched.bind(this, 'voucherConfig')} />
                                </Col>
                            : ''}
                            <Col>
                                <CustomInput type="switch" label={<FormattedMessage id="EditVoucher.InternalConsumption" />} checked={voucherConfig.isInternalConsumption} name="isInternalConsumption" id="isInternalConsumption" onChange={this.props.handleSwitched.bind(this, 'voucherConfig')} />
                            </Col>
                            <Col>
                                <CustomInput type="switch" label={<FormattedMessage id="EditVoucher.AdminRestricted" />} checked={voucherConfig.adminRestricted} name="adminRestricted" id="adminRestricted" onChange={this.props.handleSwitched.bind(this, 'voucherConfig')} />
                            </Col>
                            <Col>
                                <CustomInput type="switch" label={<FormattedMessage id="EditVoucher.Active" />} checked={voucherConfig.active} name="active" id="active" onChange={this.props.handleSwitched.bind(this, 'voucherConfig')} />
                            </Col>
                        </Row>
                    </div>
                    <Row className="my-2">
                        <Col className="col-2">
                            <Label><b><FormattedMessage id="EditVoucher.Translations" /></b></Label>
                        </Col>
                        <Col>
                            <MultiLangTextWithTitle
                                textList={voucherConfig.multiLingual}
                                updateTitle={this.props.udpateText.bind(this)}
                                udpateDescription={this.props.udpateText.bind(this)}
                                hasShortDesc={true}
                                titleMaxLength={VOUCHER_TITLE_MAX_LENGTH}
                            />
                        </Col>
                    </Row>


                    {voucherConfig.isPaymentMode === false ?
                        <div>
                            <Row>
                                <Col>
                                    <h5><FormattedMessage id="EditVoucher.ApplicableVAT" /></h5>
                                </Col>
                                <Col className="text-right">
                                    <Authorization
                                        perform="cardConfigWizard:saveConfig"
                                        yes={() => (
                                            <Button className="btn-host btn-sm" onClick={() => this.props.toggleModal('vatModal')}>
                                                <i className="fa-solid fa-plus " />
                                            </Button>
                                        )}
                                        no={() => <div></div>}
                                    />
                                </Col>
                            </Row>
                            <hr className="my-1 border-host" />
                            <Row>
                                <Col>
                                    <b><FormattedMessage id="EditVoucher.TaxCode" /></b>
                                </Col>
                                <Col>
                                    <b><FormattedMessage id="EditVoucher.Amount" /></b>
                                </Col>
                                <Col className="col-1" />
                            </Row>

                            {voucherConfig.voucherTypeVat && voucherConfig.voucherTypeVat.map((vat, key) =>
                                <Row key={key} className="my-1">
                                    <Col>
                                        {taxCodes.some(tc => tc.value === vat.taxCode) ? taxCodes.find(tc => tc.value === vat.taxCode).label : vat.taxCode}
                                    </Col>
                                    <Col>
                                        {parseFloat(vat.amount).toFixed(2)}
                                    </Col>
                                    <Col className="col-1">
                                        <i className="fa-solid fa-trash-can" style={{ cursor: 'pointer' }} onClick={(e) => this.props.handleVoucherTypeVat(e, vat)} />
                                    </Col>
                                </Row>
                            )}
                        </div>
                        : ''}
                </Form>
            </BlankCard>
        );
    }
}

export default injectIntl(VoucherConfigStep1)